import { PageTemplate } from "../../templates/PageTemplate";
import { LEGAL_CONTACTS, LEGAL_REVIEW_FLAGS } from "../../../lib/legal/config";

export function SupportPage() {
  return (
    <PageTemplate
      id="support-page"
      header={{
        kicker: "Support",
        title: "Monyawn support and implementation guidance",
        description:
          "Use these resources to troubleshoot workflows, understand product behavior, and report issues with clear reproduction steps.",
      }}
    >
      <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <article className="rounded-[1.75rem] border border-black/10 bg-white/70 p-6">
          <h2 className="text-xl font-bold text-brand-ink tracking-[-0.02em]">Where to start</h2>
          <ul className="mt-4 space-y-3 text-sm text-brand-muted leading-relaxed list-disc pl-5">
            <li>Run local verification with build, unit, and smoke tests before filing issues.</li>
            <li>Use Product Truth and Technical Spec docs to confirm intended behavior.</li>
            <li>Capture screenshots or steps when reporting UI or workflow defects.</li>
          </ul>
        </article>

        <article className="rounded-[1.75rem] border border-black/10 bg-white/70 p-6">
          <h2 className="text-xl font-bold text-brand-ink tracking-[-0.02em]">Support channels</h2>
          <div className="mt-4 space-y-3 text-sm text-brand-muted leading-relaxed">
            <p>
              Repository issues and technical documentation are the primary support path for this
              release stage.
            </p>
            <a
              href="https://github.com/cadguardianllc/sbs_opportunity_management_panel/issues"
              target="_blank"
              rel="noreferrer"
              className="inline-flex px-4 py-2 rounded-full border border-black/10 bg-brand-surface font-semibold text-brand-ink hover:bg-black/5 transition-colors"
            >
              Open GitHub issues
            </a>
          </div>
        </article>
      </section>

      <section className="mt-8 rounded-[1.75rem] border border-black/10 bg-white/60 p-6">
        <h2 className="text-xl font-bold text-brand-ink tracking-[-0.02em]">Support scope</h2>
        <p className="mt-3 text-sm text-brand-muted leading-relaxed max-w-[72ch]">
          Monyawn is currently a local-first web application. Support guidance focuses on browser
          behavior, workflow integrity, local data controls, and export reliability.
        </p>
        <p className="mt-3 text-sm text-brand-muted leading-relaxed max-w-[72ch]">
          Legal notices: {LEGAL_CONTACTS.legalNoticeEmail}. Privacy requests:{" "}
          {LEGAL_CONTACTS.privacyEmail}. Security reports: {LEGAL_CONTACTS.securityEmail}.{" "}
          {LEGAL_REVIEW_FLAGS.ownerDecision}: replace placeholder contacts before public launch.
        </p>
      </section>
    </PageTemplate>
  );
}
